import React, { ReactElement, SVGProps } from 'react';

export const SvgLinkedin = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg fill="none" height={45} width={45} {...props}>
      <circle fill="#25C5B0" r={22.5} cy={22.5} cx={22.5} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.568 18.192h-.02c-1.06 0-1.746-.693-1.746-1.571 0-.896.706-1.574 1.787-1.574 1.079 0 1.743.677 1.764 1.571 0 .878-.685 1.574-1.785 1.574zm13.243 10.197h-3.317v-4.69c0-1.228-.52-2.066-1.66-2.066-.873 0-1.358.565-1.584 1.11-.075.173-.074.405-.072.644V28.389h-3.286s.042-8.308 0-9.064h3.286v1.423c.194-.622 1.244-1.51 2.92-1.51 2.08 0 3.713 1.304 3.713 4.111zm-11.705-9.064H16.18v9.063h2.926z"
        fill="#fff"
      />
    </svg>
  );
};
